import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpProgressEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { MycontentserviceService } from './mycontentservice.service';



declare let shaka: any | undefined;
declare var window: any | undefined;

@Injectable({ providedIn: 'root' })
export class DownloadProgressService {
  isDownloadInprogress = false;
  downloadProgressPercentage = 0;
  completeStatusSent = false;
  currentDownloadVideoId: string | undefined;
  downloadingVideoDetails: { categoryId?: any; vidLibId: string } = {} as any;
  downloadCompletedEvent = new Subject<{ success: boolean, item: any }>();
  progress$ = new Subject<{ vidLibId?: string; percent: number }>(); // ✅ new
  currentDownloadContent: any;
  clickLocked = false;

  private progressListener = (event: any) => {
    try {
      const detail = event?.detail ?? event;
      if (!detail) return;
      this.prepareDownloadData({ detail });
    } catch (e) {
      console.error('[Download] progress listener error:', e);
    }
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private mycontentservice: MycontentserviceService
  ) {
    this.initializeEventListener();
  }

  initializeEventListener() {
    window.removeEventListener('downloadProgress', this.progressListener as EventListener);
    window.addEventListener('downloadProgress', this.progressListener as EventListener);
  }

  async fetchThumbnailBlob(thumbnailUrl: string): Promise<Blob> {
    const res = await fetch(thumbnailUrl);
    if (!res.ok) throw new Error(`Failed to fetch thumbnail: ${res.statusText}`);
    return await res.blob();
  }

  downloadProgress(url: string) {
    const req = new HttpRequest('GET', url, { reportProgress: true, responseType: 'blob' });
    return this.http.request(req);
  }

  prepareDownloadData(contentEvt: any) {
    const content = contentEvt?.detail;
    if (!content) return;
    this.downloadingVideoDetails = {
      vidLibId: content.appMetadata?.vidLibId || '',
      categoryId: content.appMetadata?.categoryId || ''
    };
    this.currentDownloadContent = content;
    let percent = 0;
    if (typeof content.progress === 'number' && content.progress >= 0 && content.progress <= 1) {
      percent = Math.round(content.progress * 100);
    } else {
      const total = content.appMetadata?.fileSize || content.size || 1;
      const downloaded = content.size || 0;
      percent = Math.min(100, Math.round((downloaded / total) * 100));
    }
    this.downloadProgressPercentage = percent;
    this.progress$.next({ vidLibId: this.downloadingVideoDetails.vidLibId, percent });
    if (percent >= 100) {
      this.isDownloadInprogress = false;
      this.currentDownloadVideoId = undefined;
      if (!this.completeStatusSent) {
        this.completeStatusSent = true;
        this.donwloadCompleted(content.originalManifestUri);
        this.downloadCompletedEvent.next({ success: true, item: null });
      }
      return;
    }
    if (!navigator.onLine) {
      console.warn('[Download] Network offline. Download will auto-resume when back online (Shaka retries).');
      this.isDownloadInprogress = true;
    }
    // if (percent === 0 && navigator.onLine) {
    //   console.warn('[Download] No progress yet — possible DRM or manifest issue.');
    //   setTimeout(() => {
    //     if (this.downloadProgressPercentage === 0 && this.isDownloadInprogress) {
    //       console.error('[Download] Still 0% after timeout — aborting download.');
    //       this.isDownloadInprogress = false;
    //       this.currentDownloadVideoId = undefined;
    //       this.resetDownloadItems();
    //       const evt = new CustomEvent('downloadFailed');
    //       window.dispatchEvent(evt);
    //       // this.showNotication('error', 'Download failed. Please try again.');
    //     }
    //   }, 20000); 
    // }
  }

  listContent() {
    return window.storage?.list?.() ?? Promise.resolve([]);
  }

  async isDownloadFileExist(originalManifestUri: string): Promise<boolean> {
    try {
      const content = await this.listContent();
      return (content || []).some(v => v.originalManifestUri?.includes(originalManifestUri));
    } catch {
      return false;
    }
  }

  async donwloadCompleted(manifestUri: string) {
    try {
      const list = await this.listContent();
      const item = (list || []).find(c => c.originalManifestUri === manifestUri && !!c.offlineUri);
      if (!item) {
        return;
      }
      console.log('[Download] completed. offlineUri=', item.offlineUri);
      this.downloadCompletedEvent.next({ success: true, item });
    } catch (e) {
      console.error('[Download] completion lookup failed:', e);
    }
  }

  resetDownloadItems() {
    this.isDownloadInprogress = false;
    this.downloadProgressPercentage = 0;
    this.completeStatusSent = false;
    this.downloadingVideoDetails = {} as any;
    this.currentDownloadVideoId = undefined;
    this.currentDownloadContent = undefined;
  }
}






// isDownloadInprogress: boolean = false;
//     downloadProgressPercentage: number = 0;
//     completeStatusSent: boolean = false;
//     currentDownloadVideoId: string;
//     pageReloading: boolean = false;
//     downloadingVideoDetails: {
//         categoryId?: any,
//         vidLibId: string
//     } = {} as {
//         categoryId?: any,
//         vidLibId: string
//     };
//     downloadCompletedEvent = new Subject();
//     currentDownloadContent: any;
//     // eventListener = new Subject();
//     constructor(private http: HttpClient, private router: Router, private mycontentservice: MycontentserviceService) {
//        this.initializeEventListener();
//     document.addEventListener('downloadProgress', (data) => {
//         this.prepareDownloadData(data);
//     });
//     }

   

//     initializeEventListener() {
//         document.addEventListener('downloadProgress', (data) => {
//             this.prepareDownloadData(data);
//         });
//     }

//     downloadProgress(url: string) {
//         const req = new HttpRequest('GET', url, {
//             reportProgress: true,
//             responseType: 'blob',

//         })
//         return this.http.request(req);
//     }

//     prepareDownloadData(content) {
//         if (content && content.detail) {
//             this.downloadingVideoDetails = {
//                 vidLibId: content.detail.appMetadata.vidLibId,
//                 categoryId: content.detail.appMetadata.categoryId
//             }
//             this.currentDownloadContent = content.detail;
//             let percentage = 0
//             if(content.detail.progress >= 1) {
//                 percentage = 100;
//             }else
//             {
//                 percentage = Math.round(100 / content.detail.appMetadata.fileSize * content.detail.size);
//             }
//             this.downloadProgressPercentage = percentage >= 100 ? 100 : percentage;
//             const isDownloadedFileExist = this.isDownloadFIleExist(content.detail.originalManifestUri);
            
//             if (this.downloadProgressPercentage >= 100 && !this.completeStatusSent && isDownloadedFileExist) {
//                this.completeStatusSent = true;
//                 this.isDownloadInprogress = false;
//                 this.currentDownloadVideoId = undefined;
//                 const inputEle = document.getElementById("inputText");
//                 inputEle['value'] = content.detail.offlineUri;
//                  this.donwloadCompleted(content.detail.originalManifestUri);
//             }
//         }
//         if(content.isCompleted) {
//             this.downloadFinished(content);
//         }
//     }
    
// downloadFinished(content) {
//     this.completeStatusSent = true;
//     this.isDownloadInprogress = false;
//     this.currentDownloadVideoId = undefined;
//     const inputEle = document.getElementById("inputText");
//     inputEle['value'] = content.detail.offlineUri;
//     this.downloadCompletedEvent.next(true);
//     this.mycontentservice.downloadedCount += 1;
// }

//     listContent() {
//         return window.storage.list();
//     }

//     async isDownloadFIleExist(originalManifestUri) {
//         let isExist = false;
//         const content = await this.listContent();
//         for (const video of (content || [])) {
//             if (video.originalManifestUri.includes(originalManifestUri)) {
//                 isExist = true;
//             }
//         }
//         return isExist;
//     }

//     async donwloadCompleted(manifestUri) {
//         const list = await this.listContent();
//         let offlineUri = '';
//         for (const content of list) {
            
//             if (content.originalManifestUri === manifestUri) {
//                 offlineUri = content.offlineUri;
//                 break;
//             }
//         }
//         console.log("url matched", offlineUri);
//         this.downloadCompletedEvent.next(true);
//         this.resetDownloadItems();
//         if(offlineUri) {
//             this.mycontentservice.downloadedCount += 1;
//             // this.router.navigate([]).then(result => { window.open(`/#/tqr/shaka-player?offlineUri=${offlineUri}`, '_blank'); });
//         }
//     }

//     resetDownloadItems() {
//         this.isDownloadInprogress = false;
//         this.downloadProgressPercentage = 0;
//         this.completeStatusSent = false;
//         this.downloadingVideoDetails = {} as any;
//     }